<div class="TotemWidget TotemWidgetCarousel card {{ fullScreen ? 'TotemWidgetCarousel--FullScreen' : '' }}">
    @if (imageList?.length) {
        <div>
            <div class="TotemWidgetCarousel-Slides"
                role="button"
                tabindex="0"
                [attr.aria-label]="'totem-a11y.carousel-open' | locTranslate"
                (click)="requestFullScreen.emit({ params: currentIndex})"
                (keydown)="onCardKeydown($event)">
                <div>
                    @for (image of imageList; track image) {
                        <div class="TotemWidgetCarousel-Slides-Item" [style.transform]="'translate(' + (-currentIndex * 100) + '%, 0%)'">
                            <app-pg-image-autosize [src]="image.file" [fit]="fullScreen ? 'contain' : 'cover'" [alt]="image.text | locTranslate"></app-pg-image-autosize>
                            @if (image.badges?.length) {
                                <div class="TotemWidgetCarousel-Slides-Item-Badges p-2">
                                    @for (badge of image.badges; track badge) {
                                        <span class="badge bg-{{badge.color || 'white'}} ms-2" [innerHTML]="badge.text"></span>
                                    }
                                </div>
                            }
                            <div class="TotemWidgetCarousel-Slides-Item-Text">
                                <div class="p-2">
                                    <h5 class="m-0">{{image.text | locTranslate}}</h5>
                                    @if (image.author) {
                                        <div>{{image.author}}</div>
                                    }
                                    @if (image.link?.url) {
                                        <div>
                                            <a [href]="image.link.url" target="_blank" rel="noopener noreferrer" class="btn btn-primary py-1 mt-2" (click)="onLinkClick(image.link.url); $event.stopPropagation()">
                                                {{image.link.text || image.link.url}}
                                                <span class="visually-hidden"> {{ 'totem-a11y.opens-new-window' | locTranslate }}</span>
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            @if (imageList.length > 1) {
                <div class="TotemWidgetCarousel-Index" role="tablist" [attr.aria-label]="'totem-a11y.carousel-open' | locTranslate">
                    <div [style.transform]="'translate(' + (50 - 100 / imageList.length * (currentIndex + 0.5)) + '%, 0%)'">
                        @for (image of imageList; track image; let i = $index) {
                            <button type="button" class="btn btn-link {{ !fullScreen ? 'btn-sm' : '' }}" (click)="currentIndex = i" [attr.aria-label]="'totem-a11y.carousel-slide' | locTranslate:'index':(i + 1)" [attr.aria-current]="i == currentIndex ? 'true' : null">
                                <i class="{{i == currentIndex ? 'fa' : 'fa-regular'}} fa-circle" aria-hidden="true"></i>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
